import { Phone, MapPin, Clock, User } from "lucide-react";
import { PHONE, TEL, OWNER, LOGO } from "./shared";

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer-section" className="bg-teal text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-sm uppercase tracking-[0.25em] text-pink font-semibold mb-4">Ready to Glow?</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl font-medium leading-tight">
              Let's make your space sparkle
            </h2>
            <p className="mt-5 text-blush text-lg leading-relaxed max-w-lg">
              Call us today for a friendly chat and a free, no-obligation quote.
              We can't wait to care for your home.
            </p>
            <a
              href={TEL}
              data-testid="footer-call-button"
              className="mt-9 inline-flex items-center gap-3 bg-pink text-teal hover:bg-white rounded-full px-9 py-4 text-lg font-medium transition-all duration-300 shadow-lg hover:-translate-y-0.5"
            >
              <Phone size={20} strokeWidth={1.5} /> {PHONE}
            </a>
          </div>

          <div className="lg:justify-self-end w-full max-w-md space-y-5">
            <div className="flex items-center gap-4 bg-white/5 rounded-2xl px-6 py-5 border border-white/10">
              <User size={22} strokeWidth={1.5} className="text-pink shrink-0" />
              <div>
                <p className="text-sm text-blush">Owner</p>
                <p className="text-lg" data-testid="owner-name">{OWNER}</p>
              </div>
            </div>
            <a href={TEL} className="flex items-center gap-4 bg-white/5 rounded-2xl px-6 py-5 border border-white/10 hover:bg-white/10 transition-colors">
              <Phone size={22} strokeWidth={1.5} className="text-pink shrink-0" />
              <div>
                <p className="text-sm text-blush">Phone</p>
                <p className="text-lg" data-testid="contact-phone">{PHONE}</p>
              </div>
            </a>
            <div className="flex items-center gap-4 bg-white/5 rounded-2xl px-6 py-5 border border-white/10">
              <MapPin size={22} strokeWidth={1.5} className="text-pink shrink-0" />
              <div>
                <p className="text-sm text-blush">Service Area</p>
                <p className="text-lg">Edmonton, AB &amp; surrounding areas</p>
              </div>
            </div>
            <div className="flex items-center gap-4 bg-white/5 rounded-2xl px-6 py-5 border border-white/10">
              <Clock size={22} strokeWidth={1.5} className="text-pink shrink-0" />
              <div>
                <p className="text-sm text-blush">Hours</p>
                <p className="text-lg">Mon – Sat &nbsp;·&nbsp; 8am – 7pm</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <img
              src={LOGO}
              alt="Tanya's Cleaning logo"
              className="w-11 h-11 rounded-full object-contain bg-white p-0.5"
            />
            <span className="font-serif-display text-xl">Tanya&apos;s Cleaning</span>
          </div>
          <p className="text-sm text-blush">
            © {new Date().getFullYear()} Tanya&apos;s Cleaning · Edmonton, AB. All rights reserved.
          </p>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-blush/80">
            Website by{" "}
            <a
              href="https://webempire.ca/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="webempire-link"
              className="text-pink hover:text-white underline underline-offset-4 transition-colors"
            >
              WebEmpire
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
